export default {
	namespaced: true,
	state: {
		checkedVal: '高速岔口',
	},
	getters: {},
	mutations: {
		setchecked(state, checkedVal) {
			state.checkedVal = checkedVal
		},
	},
}
